interface PlannedMealItem1 {
  foodPortion: {
    amount: number;
    weightGrams: number;
  };
  amount: number;
}

interface PlannedMealItem2 {
  food: {
    epWeightGrams: number;
  };
  foodPortion: {
    amount: number;
    weightGrams: number;
  };
  amount: number;
}

export function getPortionWeightGrams(
  portion: PlannedMealItem1["foodPortion"],
  amount = 1
): number {
  const portionWeightPerAmount = portion.weightGrams / portion.amount;
  return portionWeightPerAmount * amount;
}

/**
 * Calculates the weight of planned meal item, accounting selected portion.
 */
export function getPlannedMealItemWeightGrams(item: PlannedMealItem1): number {
  return getPortionWeightGrams(item.foodPortion, item.amount);
}

/**
 * Returns the multiplier of planned meal item to calculate nutrients like
 * energy, carbohydrates, etc.
 */
export function getPlannedMealItemWeightMultiplier(
  item: PlannedMealItem2
): number {
  const itemWeight = getPlannedMealItemWeightGrams(item);
  return itemWeight / item.food.epWeightGrams;
}
